import React, { useMemo } from 'react';
import Box from '../../../../../../components/Box';
import ButtonGroup from '../../../../../../components/ButtonGroup';
import Icon from '../../../../../../components/Icon';
import IconButton from '../../../../../../components/IconButton';
import Table from '../../../../../../components/Table';
import Tags from '../../../../../../components/Tags';
import { makeStyles } from '../../../../../../utils/styles';
import { parseDepartments } from '../../../../../../utils/helpers';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(css => ({
    iconButtons: css`
        justify-content: flex-end;
    `,
    tags: css`
        max-width: 380px;
    `,
}));

const TableDepartments = ({ departments, handleClickDuplicate, handleClickEdit, handleClickDelete }) => {
    const { t } = useTranslation()
    const styles = useStyles();

    const columns = useMemo(
        () => [
            {
                Header: t('Dział obiektu'),
                accessor: 'name'
            },
            {
                Header: t('Manager działu'),
                accessor: 'manager'
            },
            {
                Header: t('Telefon'),
                accessor: 'phone'
            },
            {
                Header: t('Zawody'),
                accessor: 'professions_ids',
                Cell: ({ cell: { value } }) => (
                    <Box customStyle={styles.tags}>
                        <Tags
                            tags={value}
                            readonly
                        />
                    </Box>
                )
            },
            {
                Header: '',
                accessor: 'options',
                Cell: ({ row }) => {
                    const { id } = row.original;

                    return (
                        <ButtonGroup customStyle={styles.iconButtons}>
                            <IconButton onClick={handleClickDuplicate(id)}>
                                <Icon
                                    name="duplicate"
                                    width={12}
                                    height={12}
                                />
                            </IconButton>
                            <IconButton onClick={handleClickEdit(id)}>
                                <Icon
                                    name="edit"
                                    width={12}
                                    height={12}
                                />
                            </IconButton>
                            <IconButton onClick={handleClickDelete(id)}>
                                <Icon
                                    name="close"
                                    width={12}
                                    height={12}
                                />
                            </IconButton>
                        </ButtonGroup>
                    )

                }
            },
        ],
        // eslint-disable-next-line
        []
    );

    const data = useMemo(() => departments && parseDepartments(departments), [departments]);

    return (
        <Table
            columns={columns}
            data={data}
            hideFooter
        />
    )
}

export default TableDepartments;
